import { useCallback, useEffect } from 'react'

import endUserSession from 'state/user/actions/endUserSession'
import { subscribeToAuthLogout } from 'state/user/authChannel'

import type { RealtimeWorkerOutputMessage } from '../realtime/types'
import useAppDispatch from './useAppDispatch'
import useRealtimeEvents from './useRealtimeEvents'

export default function useAuthSessionSync(isLoggedIn: boolean): void {
    const dispatch = useAppDispatch()

    const handleRealtimeMessage = useCallback(
        (message: RealtimeWorkerOutputMessage) => {
            if (
                message.type === 'session_expired' ||
                (message.type === 'disconnected' && message.reason === 'logout')
            ) {
                dispatch(endUserSession())
            }
        },
        [dispatch],
    )

    useEffect(
        () => subscribeToAuthLogout(() => dispatch(endUserSession())),
        [dispatch],
    )

    useRealtimeEvents(handleRealtimeMessage, isLoggedIn)
}
